import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-form-group',
    templateUrl: './form-group.component.html',
    standalone: false
})
export class FormGroupComponent implements OnInit {

  constructor() { }

  public ngOnInit() {
  }
}
